export const ACTION = {
  EDIT: 'edit',
  CREATE: 'create',
  REMOVE: 'remove',
  SHOW: 'show',
  DENY: 'deny',
  DELETE: 'This item will be delete',
  CREATE_AND_ADD: 'Create and close',
  SAVE: 'save',
  UPDATE: 'update',
  APPROVE: 'approved',
};

export const FILTER_DEFAULT = {
  CRM_OBJECT_TYPE_LOOKUP: 'crm_object_type_lookup[eq]=APPLICATION',
};
